export default __webpack_public_path__ + "static/media/sk.2055cb50.svg";